import script from "./Message.vue?vue&type=script&setup=true&lang=ts"
export * from "./Message.vue?vue&type=script&setup=true&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=52111d1a&lang=scss&scoped=true"
import "./Message.vue?vue&type=style&index=1&id=52111d1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52111d1a"]])

export default __exports__